// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.footer-container {
    /* height: 100%;
    width: 100%; */
    margin-top: 50px;
    background-color: rgba(245,245,245,255);
    /* display: flex;
    flex-direction: column; */
}
.footer-logo-container {
    text-align: right;
}
.footer-link-logo-container {
    /* display: flex;
    align-items: center;
    justify-content: space-between; */
    /* padding-left: 40px;
    padding-right: 40px; */
    padding: 35px 15px;
}

.footer-link-container {
    display: flex;
    flex-direction: column;
    list-style: none;
    width: 100%;
    /* margin-top: 50px; */
}

.footer-link-list {
    text-align: left;
    /* padding-bottom: 34px; */
    font-size: 22px;
    font-weight: 500;
    /* font-weight: normal;
    font-style: normal; */
    color: rgba(0,0,0,1);
    /* line-height: 38px; */
    /* margin-top: -15.5px; */
    /* white-space: nowrap;
    overflow: visible; */
    margin-bottom: 20px;
    /* top: 5755px;
    left: 201px; */
    /* margin-left: 10px; */
}

.footer-link-text {
    color: rgba(0,0,0,1);
    cursor: pointer;
    font-weight: 500;
}

.footer-link-text:hover {
    color: rgba(0,0,0,1);
}

/* .footer-line {
    border-top: 1px solid #fff;
} */

/* .footer-copyrights-followus-container {
    display: flex;
    justify-content: space-between;
    background-color: #808080;
    /* padding-right: 40px; 
} */

/* .footer-followus-container {
    width: 50%;
    height: 60px;
    background-color: #eae8e8;
} */
.links{
    justify-content: center;
    display: flex;
    /* align-items: center;
    width: 90%;
    height: 45px;
    margin-left: 15px;
    margin-top: 8px; */
    background-color: #ffffff;
}
.links div {
    border: 1px solid #333;
    width: 30px;
    height: 30px;
    line-height: 30px;
    font-size: 18px;
    color: #333;
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 10px 5px;

}
.footer-follow-us {
    color: #f4f4f4;
    background:#808080;
    padding: 20px;
    text-align: left;
    font-size: 15px;
}

.footer-followus-container {
    background: #eae8e8;
    padding: 7px;
}
.footer-address {
    /* left: 743px;
	top: 5816px;
	margin-left: 90px;
	width: 420px;
	white-space: nowrap;
	text-align: left;
	font-style: normal;
	font-weight: normal; */
	font-size: 28px;
	color: rgba(0,0,0,1);
}

.footer-address ul{
    list-style-type: none;
    padding: 0;
}
.footer-address ul li {
    font-size: 16px;
}
.contact-us {
    font-weight: 500;
    font-size: 22px;
    margin-bottom: 20px;
    /* padding-bottom: 17px;
    margin-left: 36px; */

}

.logo-footer {
    width: 100% !important;
    height: 100% !important;
    margin-left: 60px;

}
.links div:hover {
    color: #ff5800;
    border-color: #ff5800;
}

@media (max-width: 991.98px) { 
    .footer-logo-container {
        text-align: center;
        margin-bottom: 20px;
        margin-top: 20px;
    }
    .footer-link-list {
        margin-bottom: 10px;
        text-align: center;
    }
    .contact-us {
        margin-bottom: 10px;
        text-align: center;
    }
    .footer-address ul {
        text-align: center;
        margin-bottom: 20px;
    }
 }
@media (max-width: 575.98px) { 
    .footer-container {
        margin-top: 30px;
    }
    .footer-link-container {
        padding: 15px;
        
    }
    .footer-link-container {
        margin-top: 10px;
    }
    .footer-address {
        width: 100%;
        padding: 15px;
    }
    .footer-logo-container {
        /* margin-bottom: 40px; */
        margin-top: 20px;
    }
    .footer-link-wrapper {
        width: 100%!important;
    }
    .footer-link-list, .footer-address ul, .contact-us {
        text-align: center;
    }
}`, "",{"version":3,"sources":["webpack://./src/assets/styles/css/pages/home/footer.css"],"names":[],"mappings":"AAAA;IACI;kBACc;IACd,gBAAgB;IAChB,uCAAuC;IACvC;6BACyB;AAC7B;AACA;IACI,iBAAiB;AACrB;AACA;IACI;;qCAEiC;IACjC;0BACsB;IACtB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,gBAAgB;IAChB,WAAW;IACX,sBAAsB;AAC1B;;AAEA;IACI,gBAAgB;IAChB,0BAA0B;IAC1B,eAAe;IACf,gBAAgB;IAChB;yBACqB;IACrB,oBAAoB;IACpB,uBAAuB;IACvB,yBAAyB;IACzB;wBACoB;IACpB,mBAAmB;IACnB;kBACc;IACd,uBAAuB;AAC3B;;AAEA;IACI,oBAAoB;IACpB,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,oBAAoB;AACxB;;AAEA;;GAEG;;AAEH;;;;;GAKG;;AAEH;;;;GAIG;AACH;IACI,uBAAuB;IACvB,aAAa;IACb;;;;sBAIkB;IAClB,yBAAyB;AAC7B;AACA;IACI,sBAAsB;IACtB,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,eAAe;IACf,WAAW;IACX,kBAAkB;IAClB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,gBAAgB;;AAEpB;AACA;IACI,cAAc;IACd,kBAAkB;IAClB,aAAa;IACb,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,mBAAmB;IACnB,YAAY;AAChB;AACA;IACI;;;;;;;uBAOmB;CACtB,eAAe;CACf,oBAAoB;AACrB;;AAEA;IACI,qBAAqB;IACrB,UAAU;AACd;AACA;IACI,eAAe;AACnB;AACA;IACI,gBAAgB;IAChB,eAAe;IACf,mBAAmB;IACnB;wBACoB;;AAExB;;AAEA;IACI,sBAAsB;IACtB,uBAAuB;IACvB,iBAAiB;;AAErB;AACA;IACI,cAAc;IACd,qBAAqB;AACzB;;AAEA;IACI;QACI,kBAAkB;QAClB,mBAAmB;QACnB,gBAAgB;IACpB;IACA;QACI,mBAAmB;QACnB,kBAAkB;IACtB;IACA;QACI,mBAAmB;QACnB,kBAAkB;IACtB;IACA;QACI,kBAAkB;QAClB,mBAAmB;IACvB;CACH;AACD;IACI;QACI,gBAAgB;IACpB;IACA;QACI,aAAa;;IAEjB;IACA;QACI,gBAAgB;IACpB;IACA;QACI,WAAW;QACX,aAAa;IACjB;IACA;QACI,yBAAyB;QACzB,gBAAgB;IACpB;IACA;QACI,qBAAqB;IACzB;IACA;QACI,kBAAkB;IACtB;AACJ","sourcesContent":[".footer-container {\n    /* height: 100%;\n    width: 100%; */\n    margin-top: 50px;\n    background-color: rgba(245,245,245,255);\n    /* display: flex;\n    flex-direction: column; */\n}\n.footer-logo-container {\n    text-align: right;\n}\n.footer-link-logo-container {\n    /* display: flex;\n    align-items: center;\n    justify-content: space-between; */\n    /* padding-left: 40px;\n    padding-right: 40px; */\n    padding: 35px 15px;\n}\n\n.footer-link-container {\n    display: flex;\n    flex-direction: column;\n    list-style: none;\n    width: 100%;\n    /* margin-top: 50px; */\n}\n\n.footer-link-list {\n    text-align: left;\n    /* padding-bottom: 34px; */\n    font-size: 22px;\n    font-weight: 500;\n    /* font-weight: normal;\n    font-style: normal; */\n    color: rgba(0,0,0,1);\n    /* line-height: 38px; */\n    /* margin-top: -15.5px; */\n    /* white-space: nowrap;\n    overflow: visible; */\n    margin-bottom: 20px;\n    /* top: 5755px;\n    left: 201px; */\n    /* margin-left: 10px; */\n}\n\n.footer-link-text {\n    color: rgba(0,0,0,1);\n    cursor: pointer;\n    font-weight: 500;\n}\n\n.footer-link-text:hover {\n    color: rgba(0,0,0,1);\n}\n\n/* .footer-line {\n    border-top: 1px solid #fff;\n} */\n\n/* .footer-copyrights-followus-container {\n    display: flex;\n    justify-content: space-between;\n    background-color: #808080;\n    /* padding-right: 40px; \n} */\n\n/* .footer-followus-container {\n    width: 50%;\n    height: 60px;\n    background-color: #eae8e8;\n} */\n.links{\n    justify-content: center;\n    display: flex;\n    /* align-items: center;\n    width: 90%;\n    height: 45px;\n    margin-left: 15px;\n    margin-top: 8px; */\n    background-color: #ffffff;\n}\n.links div {\n    border: 1px solid #333;\n    width: 30px;\n    height: 30px;\n    line-height: 30px;\n    font-size: 18px;\n    color: #333;\n    border-radius: 50%;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    margin: 10px 5px;\n\n}\n.footer-follow-us {\n    color: #f4f4f4;\n    background:#808080;\n    padding: 20px;\n    text-align: left;\n    font-size: 15px;\n}\n\n.footer-followus-container {\n    background: #eae8e8;\n    padding: 7px;\n}\n.footer-address {\n    /* left: 743px;\n\ttop: 5816px;\n\tmargin-left: 90px;\n\twidth: 420px;\n\twhite-space: nowrap;\n\ttext-align: left;\n\tfont-style: normal;\n\tfont-weight: normal; */\n\tfont-size: 28px;\n\tcolor: rgba(0,0,0,1);\n}\n\n.footer-address ul{\n    list-style-type: none;\n    padding: 0;\n}\n.footer-address ul li {\n    font-size: 16px;\n}\n.contact-us {\n    font-weight: 500;\n    font-size: 22px;\n    margin-bottom: 20px;\n    /* padding-bottom: 17px;\n    margin-left: 36px; */\n\n}\n\n.logo-footer {\n    width: 100% !important;\n    height: 100% !important;\n    margin-left: 60px;\n\n}\n.links div:hover {\n    color: #ff5800;\n    border-color: #ff5800;\n}\n\n@media (max-width: 991.98px) { \n    .footer-logo-container {\n        text-align: center;\n        margin-bottom: 20px;\n        margin-top: 20px;\n    }\n    .footer-link-list {\n        margin-bottom: 10px;\n        text-align: center;\n    }\n    .contact-us {\n        margin-bottom: 10px;\n        text-align: center;\n    }\n    .footer-address ul {\n        text-align: center;\n        margin-bottom: 20px;\n    }\n }\n@media (max-width: 575.98px) { \n    .footer-container {\n        margin-top: 30px;\n    }\n    .footer-link-container {\n        padding: 15px;\n        \n    }\n    .footer-link-container {\n        margin-top: 10px;\n    }\n    .footer-address {\n        width: 100%;\n        padding: 15px;\n    }\n    .footer-logo-container {\n        /* margin-bottom: 40px; */\n        margin-top: 20px;\n    }\n    .footer-link-wrapper {\n        width: 100%!important;\n    }\n    .footer-link-list, .footer-address ul, .contact-us {\n        text-align: center;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
